import Marquee from "react-marquee-slider";
import styled from "styled-components";
import img1 from "../assets/img/BlueImz.png";
import img2 from "../assets/img/BDR.png";
import img3 from "../assets/img/Victor.png";
import img4 from "../assets/img/BlueImz.png";
import img5 from "../assets/img/BDR.png";
import img6 from "../assets/img/Victor.png";
import img7 from "../assets/img/BlueImz.png";
import img8 from "../assets/img/BDR.png";
import img9 from "../assets/img/Victor.png";
import img10 from "../assets/img/BDR.png";

export default function HappyCustomer() {
  const BoxClient = styled.div`
    width: 400px;
    height: 180px;
    border: 3px solid #6debb5;
    margin-right: 2rem;
    padding: .8rem;
    div > img {
      padding: 12px;
    }

  `;

  const Item = [
    {
      id: 1,
      photo: img1,
      name: "BluAimz",
      jobTitle: "Programador Front-End",
      text: "Programador do projeto, sou criador do BlueWorld um bot do Discord com multifunções desde administração e também diversão.",
    },
    {
      id: 2,
      photo: img2,
      name: "BDarkBR",
      jobTitle: "Desenvolvedor Full-Stack",
      text: "Criador e Programador do projeto, sou programador há 4 anos e meio e atuo principalmente na área de Front-End e Back-And.",
    },
    {
      id: 3,
      photo: img3,
      name: "Victor",
      jobTitle: "Administrador Da Code Tech Store",
      text: "Administrador do projeto, trabalho atualmente com Marketing, Investimentos com Organização de empresas.",
    },
    {
      id: 4,
      photo: img4,
      name: "BluAimz",
      jobTitle: "Programador Front-End",
      text: "Programador do projeto, sou criador do BlueWorld um bot do Discord com multifunções desde administração e também diversão.",
    },

    {
      id: 5,
      photo: img5,
      name: "BDarkBR",
      jobTitle: "Desenvolvedor Full-Stack",
      text: "Criador e Programador do projeto, sou programador há 4 anos e meio e atuo principalmente na área de Front-End e Back-And.",
    },
  ];

  const Item2 = [
    {
      id: 1,
      photo: img6,
      name: "Victor",
      jobTitle: "Administrador Da Code Tech Store",
      text: "Administrador do projeto, trabalho atualmente com Marketing, Investimentos com Organização de empresas.",
    },
    {
      id: 2,
      photo: img7,
      name: "BluAimz",
      jobTitle: "Programador Front-End",
      text: "Programador do projeto, sou criador do BlueWorld um bot do Discord com multifunções desde administração e também diversão.",
    },
    {
      id: 3,
      photo: img8,
      name: "BDarkBR",
      jobTitle: "Desenvolvedor Full-Stack",
      text: "Criador e Programador do projeto, sou programador há 4 anos e meio e atuo principalmente na área de Front-End e Back-And.",
    },
    {
      id: 4,
      photo: img9,
      name: "Victor",
      jobTitle: "Administrador Da Code Tech Store",
      text: "Administrador do projeto, trabalho atualmente com Marketing, Investimentos com Organização de empresas.",
    },

    {
      id: 5,
      photo: img10,
      name: "BDarkBR",
      jobTitle: "Desenvolvedor Full-Stack",
      text: "Criador e Programador do projeto, sou programador há 4 anos e meio e atuo principalmente na área de Front-End e Back-And.",
    },
  ];

  return (
    <>
      <h1 className="text-center my-4 font-secondary color-primary fs-40" >
        Equipe e Colaboradores
      </h1>
      <div style={{ height: "220px" }}>
        <Marquee velocity={10}>
          {Item.map((item) => (
            <BoxClient className="d-flex align-items-center justify-contents-center">
              <div class="d-flex align-items-start justify-content-between">
                <img src={item.photo} fluid alt={item.name}/>
                <div>
                  <h5 className="font-primary color-secondary">{item.name}</h5>
                  <p className="font-secondary color-primary fs-12">
                    <u>
                      <b>{item.jobTitle}</b>
                    </u>
                    <br />
                    {item.text}
                  </p>
                </div>
              </div>
            </BoxClient>
          ))}
        </Marquee>
      </div>

      <div style={{ height: "220px" }}>
        <Marquee direction="ltr" velocity={10}>
          {Item2.map((item) => (
            <BoxClient className="d-flex align-items-center justify-contents-center">
              <div class="d-flex align-items-start justify-content-between">
                <img src={item.photo} fluid alt={item.name}/>
                <div>
                  <h5 className="font-primary color-secondary">{item.name}</h5>
                  <p className="font-secondary color-primary fs-12">
                    <u>
                      <b>{item.jobTitle}</b>
                    </u>
                    <br />
                    {item.text}
                  </p>
                </div>
              </div>
            </BoxClient>
          ))}
        </Marquee>
      </div>
    </>
  );
}
